import axios from 'axios';

import React, { useState } from 'react';
import { setError } from '../../../redux/actions';
import { useDispatch } from 'react-redux';

export default function AddImage({ newImage, onImageChange }) {
  const distpatch = useDispatch();

  const onFileChange = (event) => {
    onImageChange(event.target.files[0]);
    distpatch(setError(''));
  };

  const fileData = () => {
    if (newImage) {
      return (
        <div>
          <h2>File Details:</h2>
          <p>File Name: {newImage.name}</p>
        </div>
      );
    } else {
      return (
        <div>
          <br />
          <h4>Choose before Pressing the Upload button</h4>
        </div>
      );
    }
  };

  return (
    <div>
      <h3>File Upload:</h3>
      <div>
        <input type="file" onChange={onFileChange} />
      </div>
      {fileData()}
    </div>
  );
}
